import React from "react";
import { Alert, CircularProgress, Collapse } from "@mui/material";
import v2Styles from "../../../../../v2Styles.module.css";

export default function JSASectionActions({ visible, updating, onCancelChanges, onSaveJSA }) {
  return (
    <Collapse in={visible}>
      <div className="container-fluid">
        <div className="row mt-3 pb-2" style={{ borderBottom: "1px solid #f5f5f5" }}>
          <div className="col-12 d-flex align-items-center justify-content-end" style={{ gap: "10px" }}>
            {updating ? (<CircularProgress size={20} />) : null}
            {visible ? (
              <Alert sx={{ pt: 0, pb: 0, alignSelf: "flex-start", fontFamily: "'Poppins', sans-serif" }} color={updating ? "info" : "warning"} icon={false}>
                {!updating ? "You have unsaved changes — click Save to apply them." : "Save in Progress, please wait."}
              </Alert>
            ) : null}
            <button onClick={() => onCancelChanges()} className={v2Styles.OutlinedButton} type="button" disabled={updating}>Discard</button>
            <button onClick={() => onSaveJSA()} className={v2Styles.SecondaryButton} type="button" disabled={updating}>Save</button>
          </div>
        </div>
      </div>
    </Collapse>
  );
}